import Notify from '@/components/notify'
export default {
    name: 'Unsubscribe',
    components: {
        Notify,
    },
    data (){
        return{

        }
    },
    created(){
    },
    methods: {

    }
}
